import CustomersTablePaginated from "../components/CustomersTablePaginated"
import ProfileAwareHeadlines from "../components/headlines/ProfileAwareHeadlines"
import CustomerCreate from "../components/CustomerCreate"
import { useCustomersPaginated } from "../hooks/useCustomersPaginated"
import { Section, SectionRoot } from "@hydrologiq/shared/chakra/custom/Section"

function CustomersPaginated() {
  const {
    customers,
    pagination,
    loading: customersLoading,
    error: customersError,
    sort,
    fetchPage,
    setPageSize,
    setSort,
    refetch,
  } = useCustomersPaginated()

  return (
    <SectionRoot>
      <Section>
        <ProfileAwareHeadlines />
      </Section>
      <Section>
        <CustomersTablePaginated
          customers={customers}
          loading={customersLoading}
          error={customersError ? customersError.message : undefined}
          onRetry={refetch}
          pagination={pagination}
          onPageChange={fetchPage}
          onPageSizeChange={setPageSize}
          sort={sort}
          onSortChange={setSort}
          headerActions={<CustomerCreate />}
        />
      </Section>
    </SectionRoot>
  )
}

export default CustomersPaginated
